import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import DropdownMenu from '@/components/common/Dropdown/DropdownMenu';
import Dropdown, { useDropdownEvents } from '@/components/common/Dropdown';
import TCIOnlyLock from '@/components/common/TCIOnlyLock';
import useFlags from '@/hooks/useFlags';
import AddSlideObject from './ContentActions/AddSlideObject';
import usePopover from './hooks/usePopover';
import useSlideShowContext from '../stores/useSlideShowContext';

interface TypeSelectorProps {
  index: number;
  modalManager: ModalManager;
  slideId: number;
}

const TypeSelector = ({ index, modalManager, slideId }: TypeSelectorProps) => {
  const ref = useRef();
  const dropdownEvents = useDropdownEvents(ref);
  const anchorId = `type-selector-anchor-${index}`;
  const openerClass = `type-selector-${index}`;
  const { coordinates } = usePopover({ anchorId, dropdownEvents, openerClass, position: 'bottom left', ref });
  const isAdmin = useSlideShowContext(state => state.isAdmin);
  const isSysAdmin = useSlideShowContext(state => state.isSysAdmin);
  const { bigBookSlideshow } = useFlags();

  return (
    <>
      <button
        className={`dropdown-toggle btn btn--green ${openerClass}`}
        id={anchorId}
        type="button"
      >
        Select Type
      </button>

      {ReactDOM.createPortal(
        <DropdownMenu
          ref={ref}
          coordinates={coordinates}
          open={dropdownEvents.open}
        >
          <AddSlideObject
            innerText="Text"
            variables={{ index, modelType: 'Text', slideId }}
          />
          {isSysAdmin && (
            <AddSlideObject
              sysadminOnly
              innerText="HTML"
              openModal={modalManager.open}
              variables={{ index, modelType: 'HTML', slideId }}
            />
          )}
          <AddSlideObject
            innerText="Image"
            openModal={modalManager.open}
            variables={{ index, modelType: 'Image', slideId }}
          />
          <AddSlideObject
            innerText="Video"
            openModal={modalManager.open}
            variables={{ index, modelType: 'Video', slideId }}
          />
          <AddSlideObject
            innerText="Questions"
            openModal={modalManager.open}
            variables={{ index, modelType: 'Question', slideId }}
          />
          {isAdmin && (
            <AddSlideObject
              innerText="3D Model"
              openModal={modalManager.open}
              variables={{ index, modelType: '3DModel', slideId }}
            />
          )}
          {isAdmin && (
            <AddSlideObject
              innerText="360 Image"
              openModal={modalManager.open}
              variables={{ index, modelType: 'PanoramicImage', slideId }}
            />
          )}
          {isSysAdmin && (
            <AddSlideObject
              sysadminOnly
              innerText="Interactive Map"
              openModal={modalManager.open}
              variables={{ index, modelType: 'InteractiveMap', slideId }}
            />
          )}
          {isSysAdmin && (
            <AddSlideObject
              sysadminOnly
              innerText="Reading"
              openModal={modalManager.open}
              variables={{ index, modelType: (bigBookSlideshow ? 'ReadingSection' : 'Section'), slideId }}
            />
          )}
          {isSysAdmin && (
            <Dropdown
              buttonClass={`
                  !tw-cursor-pointer tw-bg-none tw-outline-none tw-border-none tw-bg-inherit tw-w-full dropdown-item
                `}
              dropdownClass="tw-px-1.5 tw-py-1.5"
              dropdownPosition="right"
              toggleText={(
                <div className="!tw-cursor-pointer tw-flex tw-items-center">
                  <div className="!tw-cursor-pointer">Vocabulary</div>
                  <TCIOnlyLock classes="ml10" />
                  <i className="!tw-cursor-pointer fa fa-icon fa-caret-right tw-ml-auto" />
                </div>
              )}
            >
              <AddSlideObject
                innerText="Card"
                openModal={modalManager.open}
                variables={{ index, modelType: 'GlossaryTermCard', slideId }}
              />
              <AddSlideObject
                innerText="+/- List"
                openModal={modalManager.open}
                variables={{ index, modelType: 'GlossaryTermList', slideId }}
              />
              <AddSlideObject
                innerText="Table"
                openModal={modalManager.open}
                variables={{ index, modelType: 'GlossaryTermTable', slideId }}
              />
            </Dropdown>
          )}
        </DropdownMenu>,
        document.body,
      )}
    </>
  );
};

export default TypeSelector;
